import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(_, __) {
    window.location.replace('/login');
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
